import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuFilterToolbarFieldLabel]',
})
export class MuFilterToolbarFieldLabelDirective {
  @Input('appMuFilterToolbarFieldLabel') name: string;

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
